export default __webpack_public_path__ + "static/media/schneider.a9eea46b.png";